import { isAndroid } from 'utils';
import {
  SYNC,
  DEPOSIT,
  WITHDRAW,
  CANCEL_WITHDRAW,
  SEND_TO,
  PREPARE_WITHDRAW,
  TRANSACTION_SOMETHING_WENT_WRONG,
  CREATE_CHANNEL,
} from 'constants/dbetSDK.js';

export const NEED_METAMASK_EXTENSION = 1;
export const MAIN_NETWORK_ERROR = 2;
export const WITHDRAW_MAX_VALUE = 3;
export const RESTORE_LOGIN = 4;
export const IS_NOT_VALID_ADDRESS = 5;
export const METAMASK_CANCEL_LOGIN = 6;
export const METAMASK_ACCOUNT_REQUEST_FAIL = 7;
export const CONNECTION_TIME_OUT = 8;
export const SYNC_NEEDED = 9;
export const IS_NOT_VALID_SEND_TO_AMOUNT = 10;
export const CONTRACT_INSUFFICIENT_FUNDS = 11;
export const IS_NOT_VALID_CONFIRM_PASSWORD = 50;
export const DEPOSIT_TRANSACTION_ERROR = 13;
export const WITHDRAW_TRANSACTION_ERROR = 14;
export const CANCEL_WITHDRAW_TRANSACTION_ERROR = 15;
export const SEND_TO_TRANSACTION_ERROR = 16;
export const PREPARE_WITHDRAW_TRANSACTION_ERROR = 17;
export const DEPOSIT_MAX_VALUE = 18;
export const SYNC_TRANSACTION_ERROR = 19;
export const WITHDRAW_WRONG_AMOUNT = 20;
export const BROWSER_NOT_SUPPORTED = 21;
export const DEPOSIT_MIN_VALUE = 22;
export const IS_NOT_VALID_USERNAME = 24;
export const IS_NOT_VALID_PASSWORD = 25;
export const IS_NOT_VALID_USER_CREDENTIALS = 26;
export const IS_NOT_VALID_SEND_TO_MIN_VALUE = 27;
export const IS_NOT_VALID_SEND_TO_LESS_THAN_ZERO = 28;
export const NO_WITHDRAW = 12;
export const CHAIN_WAS_ADDED = 30;
export const NEW_ACCOUNT_HISTORY = 31;
export const WRONG_CONNECTED_PROVIDER = 32;
export const NOT_CONNECTED_TO_ADD_NETWORK = 33;
export const UNAUTHORIZED_USER_WITHDRAW_ERROR = 34;
export const SOMETHING_WENT_WRONG = 100;
export const CHANNEL_CREATE_ERROR = 101;
export const WITHDRAW_MIN_AMOUNT = 102;
export const DEPOSIT_INVALID_INPUT = 103;

export const errorMessages = {
  [CONTRACT_INSUFFICIENT_FUNDS]: 'errorContractInsufficientFunds',
  [IS_NOT_VALID_ADDRESS]: 'errorIsNotValidAddress',
  [IS_NOT_VALID_CONFIRM_PASSWORD]: 'errorIsNotValidConfirmPassword',
  [DEPOSIT_MIN_VALUE]: 'errorDepositMinValue',
  [DEPOSIT_INVALID_INPUT]: 'errorDepositInvalidValue',
  [SOMETHING_WENT_WRONG]: 'errorSomethingWentWrong',
  [WITHDRAW_MAX_VALUE]: 'errorWithdrawMaxValue',
  [NO_WITHDRAW]: 'errorNoWithDraw',
  [WITHDRAW_WRONG_AMOUNT]: 'errorWithdrawMinValue',
  [WITHDRAW_MIN_AMOUNT]: 'errorMinWithdrawAmount',
  [IS_NOT_VALID_SEND_TO_AMOUNT]: 'errorIsNotValidSendToAmount',
  [IS_NOT_VALID_SEND_TO_LESS_THAN_ZERO]: 'errorIsNotValidSendToLessThanZero',
  [IS_NOT_VALID_SEND_TO_MIN_VALUE]: 'errorIsNotValidSendToMinValue',
  [IS_NOT_VALID_USER_CREDENTIALS]: 'errorIsNotValidUserCredentials',
  [DEPOSIT_MAX_VALUE]: 'errorDepositMaxValue',
  [IS_NOT_VALID_USERNAME]: 'errorIsNotValidUsername',
  [IS_NOT_VALID_PASSWORD]: 'errorIsNotValidPassword',
  [DEPOSIT_TRANSACTION_ERROR]: 'errorDepositTransactionError',
  [SYNC_TRANSACTION_ERROR]: 'errorSyncTransactionError',
  [WITHDRAW_TRANSACTION_ERROR]: 'errorWithdrawTransactionError',
  [CANCEL_WITHDRAW_TRANSACTION_ERROR]: 'errorCancelWithdrawTransactionError',
  [SEND_TO_TRANSACTION_ERROR]: 'errorSendToTransactionError',
  [PREPARE_WITHDRAW_TRANSACTION_ERROR]: 'errorPrepareWithdrawTransactionError',
  [BROWSER_NOT_SUPPORTED]: 'errorBrowserNotSupported',
  [MAIN_NETWORK_ERROR]: 'errorMainNetworkError',
  [METAMASK_ACCOUNT_REQUEST_FAIL]: 'errorMetamaskAccountRequestFail',
  [METAMASK_CANCEL_LOGIN]: 'errorMetamaskCancelLogin',
  [CONNECTION_TIME_OUT]: 'errorConnectionTimeOut',
  [SYNC_NEEDED]: 'errorSyncNeeded',
  [CHANNEL_CREATE_ERROR]: 'errorChannelCreateTransactionError',
  [CHAIN_WAS_ADDED]: 'errorChainWasAdded',
  [WRONG_CONNECTED_PROVIDER]: 'errorWrongConnectedProvider',
  [NOT_CONNECTED_TO_ADD_NETWORK]: 'errorNotConnectedToAddNetwork',
  [UNAUTHORIZED_USER_WITHDRAW_ERROR]: 'errorUnauthorizedWithdraw',
  [NEW_ACCOUNT_HISTORY]: 'errorNewAccountHistory',
  [NEED_METAMASK_EXTENSION]: isAndroid
    ? 'errorNeedAndroidMetamaskExtension'
    : 'errorNeedMetamaskExtension',
};

export const mapTransactionTypeToError = {
  [SYNC]: SYNC_TRANSACTION_ERROR,
  [DEPOSIT]: DEPOSIT_TRANSACTION_ERROR,
  [SEND_TO]: SEND_TO_TRANSACTION_ERROR,
  [WITHDRAW]: WITHDRAW_TRANSACTION_ERROR,
  [CANCEL_WITHDRAW]: CANCEL_WITHDRAW_TRANSACTION_ERROR,
  [PREPARE_WITHDRAW]: PREPARE_WITHDRAW_TRANSACTION_ERROR,
  [TRANSACTION_SOMETHING_WENT_WRONG]: SOMETHING_WENT_WRONG,
  [CREATE_CHANNEL]: CHANNEL_CREATE_ERROR,
};

export const metamaskErrorIds = [
  MAIN_NETWORK_ERROR,
  METAMASK_CANCEL_LOGIN,
  NEED_METAMASK_EXTENSION,
  METAMASK_ACCOUNT_REQUEST_FAIL,
];
